const columns = [
  {
    title: "题材分类",
    links: [
      { label: "后宫恋爱", href: "#category" },
      { label: "逆后宫", href: "#category" },
      { label: "暧昧攻略", href: "#category" },
      { label: "高甜日常", href: "#category" },
      { label: "经典神作", href: "#category" },
    ],
  },
  {
    title: "专题攻略",
    links: [
      { label: "逆后宫入坑指南", href: "#feature" },
      { label: "暧昧攻略进阶", href: "#feature" },
      { label: "高甜日常清单", href: "#feature" },
      { label: "恋爱番新手入门", href: "#feature" },
    ],
  },
  {
    title: "更多",
    links: [
      { label: "追番时间表", href: "#timeline" },
      { label: "常见问题", href: "#faq" },
      { label: "关于本站", href: "#about" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-200">
      <div className="mx-auto max-w-[1400px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div className="md:col-span-1">
            <a href="#top" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-white">
                <i className="ri-heart-3-fill text-lg"></i>
              </span>
              <span className="font-display text-xl text-foreground-950">女神动漫</span>
            </a>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-600">
              专注后宫、恋爱、暧昧、攻略与逆后宫题材的动漫推荐专区，帮你快速定位合口味的女神动漫恋爱故事。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {["ri-twitter-x-line", "ri-bilibili-line", "ri-weibo-line", "ri-mail-line"].map(
                (icon) => (
                  <a
                    key={icon}
                    href="#about"
                    aria-label="社交链接"
                    className="flex h-9 w-9 items-center justify-center rounded-full bg-background-100 text-foreground-700 transition-colors hover:bg-primary-500 hover:text-white"
                  >
                    <i className={`${icon} text-base`}></i>
                  </a>
                ),
              )}
            </div>
          </div>

          {columns.map((col) => (
            <div key={col.title}>
              <h4 className="font-display text-sm text-foreground-950">{col.title}</h4>
              <ul className="mt-4 flex flex-col gap-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-300 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-600">
            © 2026 女神动漫 · 后宫恋爱番推荐专区，保留所有权利
          </p>
          <p className="text-xs text-foreground-500">追更不再迷路，甜番一次看个够</p>
        </div>
      </div>
    </footer>
  );
}